import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import { pageSizes } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import setUrl from '@/mixins/setUrl';

export default {
  name: 'case-history',
  components: { HisAutocompleteSuggestions },
  mixins: [pageSize, setUrl],

  data() {
    return {
      total: 0,
      pageSizes,
      input: 0,
      form: {
        resource: '',
      },
      query: {
        diagnosis: '',
        patientNameOrPhoneNo: '',
        currentPage: 1,
        pageSize,
      },
      tableData: [],
    };
  },

  methods: {
    // 跳转详情
    goDetail(ids) {
      this.$router.push({ path: 'caseDetail', query: { id: ids } });
    },
    // 跳转编辑
    goEdit(id, modle) {
      if (modle === 3) {
        this.$router.push({ path: 'outMedicalRecord', query: { rid: id, type: 'supplement' } });
      } else {
        this.$router.push({ path: 'outMedicalRecord', query: { rid: id } });
      }
    },
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.queryChangeHandle();
      this.$api.outPatient.caseHistory(this.query).then((res) => {
        console.log(res);
        this.total = res.totalSize;
        this.tableData = res.historyRecordList;
      });
    },
    handleSizeChange() {
      this.getTableData(1);
    },
    handleCurrentChange(value) {
      console.log(value);
      this.query.currentPage = value;
      this.getTableData();
    },
    querySearch(queryString, cb) {
      let list = []; // 查询出的标准库药品
      this.query.patientNameOrPhoneNo = queryString;
      this.$api.member.search({
        nameOrPhone: queryString,
      }).then((res) => {
        console.log(res);
        list = res.map(item => ({
          patientName: item.patientName,
          phoneNo: item.phoneNo,
        }));
        cb(list);
      });
    },
    // 选中药品
    handleSelectDrug(e) {
      this.query.patientNameOrPhoneNo = e.patientName;
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        patientNameOrPhoneNo: this.query.patientNameOrPhoneNo,
        diagnosis: this.query.diagnosis,
        currentPage: this.query.currentPage,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.query.patientNameOrPhoneNo = queryUrl.patientNameOrPhoneNo ? queryUrl.patientNameOrPhoneNo : '';
      this.query.diagnosis = queryUrl.diagnosis ? queryUrl.diagnosis : '';
      this.query.currentPage = queryUrl.currentPage ? Number(queryUrl.currentPage) : 1;
      this.getTableData();
    },
  },
  mounted() {
    this.initQuery();
  },
};
